module.exports = __webpack_public_path__ + "static/img/A11.71a7c909.jpg";